import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  FaHome,
  FaBuilding,
  FaCalendarAlt,
  FaFileAlt,
  FaBookOpen,
  FaChevronLeft,
  FaChevronRight,
  FaSuitcase,
  FaClinicMedical,
} from "react-icons/fa";
import { useIsMobile } from "../../hooks/use-mobile";
import { getImg } from "../../Api/getImg";
import { IoBarChartSharp, IoQrCode } from "react-icons/io5";
import { HiSparkles, HiUserMinus } from "react-icons/hi2";
import { FaChartColumn, FaPage4, FaServer, FaUserDoctor } from "react-icons/fa6";
import { FaBlog } from "react-icons/fa6";
import {
  BsBookHalf,
  BsBuilding,
  BsClockFill,
  BsHospital,
  BsImages,
  BsNewspaper,
  BsPeople,
  BsPersonLock,
  BsPlaystation,
  BsQrCode,
  BsTools,
} from "react-icons/bs";
import { PiPackage, PiUserRectangleThin } from "react-icons/pi";
import { TbPackages } from "react-icons/tb";
import { SiBurgerking, SiSession, SiSessionize, SiUnsplash } from "react-icons/si";
import { BiAnalyse, BiBell, BiBox, BiChart, BiPhone, BiStar, BiUserCircle } from "react-icons/bi";
import { GiDoctorFace } from "react-icons/gi";
import { IoIosSad } from "react-icons/io";
import { MdFolderSpecial } from "react-icons/md";
import { CgChart, CgGirl } from "react-icons/cg";
import {
  CalendarOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
const Sidebar = ({ isOpen, onToggle, user, isLoading }) => {
  const [userRole, setUserRole] = useState(null);
  const isMobile = useIsMobile();

  // Update role reactively when localStorage changes
  useEffect(() => {
    const updateRole = () => {
      const role = localStorage.getItem("role");
      setUserRole(role ? parseInt(role) : null);
    };

    updateRole();

    window.addEventListener("storage", updateRole);

    window.addEventListener("roleChanged", updateRole);

    return () => {
      window.removeEventListener("storage", updateRole);
      window.removeEventListener("roleChanged", updateRole);
    };
  }, []);

  const allNavItems = [
     {
      name: "Scan QR",
      path: "/scanQr",
      icon: <BsQrCode size={18} />, 
      roles: [4],
    },
    {
      name: "Dashboard & Analysis",
      path: "/dashboard",
      icon: <FaHome size={18} />,
      roles: [3],
    },
     {
      name: "Dashboard ",
      path: "dashboard-analysis",
      icon: <FaHome size={18} />,
      roles: [7],
    },
    {
      name: "Insights ",
      path: "/insights",
      icon: <BiChart size={18} />,
      roles: [7],
    },
   
    {
      name: "Center Performance",
      path: "/clinics-performance",
      icon: <FaChartColumn   size={18} />,
      roles: [7],
    },
    {
      name: "Services Statistics",
      path: "/services-analysis",
      icon: <CgChart   size={18} />,
      roles: [3,  7],
    },

      {
      name: "Center management",
      path: "/management",
      icon: <FaBuilding size={18} />,
      roles: [3],
    },
     {
      name: "QR Generation",
      path: "/QrGeneration",
      icon: <IoQrCode size={18} />,
      roles: [4],
    },
    {
      name: "Bookings",
      path: "/all-bookings",
      icon: <FaBookOpen size={18} />,
      roles: [3, 4,7],
    },
    // { name: "Sessions ", path: "/specialist-bookings-screen", icon: <BsClockFill size={18} />, roles: [ 3,4] },
    // {
    //   name: "Insights",
    //   path: "/insights",
    //   icon: <IoBarChartSharp size={18} />,
    //   roles: [3],
    // },
  
     {
      name: "Clinis Management",
      path: "/clinics",
      icon: <FaClinicMedical size={18} />,
      roles: [4],
    },
     {
      name: "Schedule",
      path: "/schedule",
      icon: <FaCalendarAlt size={18} />,
      roles: [3,4],
    },
    

    {
      name: "Patients",
      path: "/patients",
      icon: <HiUserMinus size={18} />,
      roles: [3, 4],
    },
   
    {
      name: "Doctors",
      path: "/doctors",
      icon: <FaUserDoctor size={18} />,
      roles: [3,4,7],
    },
    {
      name: "External Consultants",
      path: "/external-consultant",
      icon: <FaUserDoctor size={18} />,
      roles: [4],
    },
    // { name: "Specialists", path: "/specialists", icon: <BiUserCircle     size={18} />, roles: [3] },
    // { name: "Invitations", path: "/send-invite", icon: <FaFileAlt size={18} />, roles: [3] },
   
   
    {
      name: "Staff",
      path: "/employees",
      icon: <BsPeople size={18} />,
      roles: [3],
    },
  
  
  
    {
      name: "SERVICES & OFFERES",
      path: "/services-packages",
      icon: <FaServer size={18} />,
      roles: [3,4,7],
    },
    { name: "Marketing & Content", path: "/marketing", icon: <BsImages size={18} />, roles: [3,4,7] },
   
  
  
    {
      name: "Human Resourses",
      path: "/human-resourses",
      icon: <FileTextOutlined size={18} />,
      roles: [3],
    },
      {
      name: "OVR",
      path: "/ovr",
      icon: <BsBookHalf size={18} />,
      roles: [3, 4],
    },
   
   
    // {
    //   name: "Contacts",
    //   path: "/contact",
    //   icon: <BiPhone size={18} />,
    //   roles: [3,4],
    // },
    // {
    //   name: "Review By Qr",
    //   path: "/reviewQr",
    //   icon: <BiStar size={18} />,
    //   roles: [3,4],
    // },
    // { name: "Subscription", path: "/sub", icon: <HiSparkles size={18} />, roles: [3] },
  ];

  // Filter navigation items based on user role
  const navItems = userRole
    ? allNavItems.filter((item) => item.roles.includes(userRole))
    : [];

  console.log("Current role:", userRole);

  const Backdrop = () =>
    isMobile && isOpen ? (
      <div className="fixed inset-0 bg-black/20 z-20" onClick={onToggle} />
    ) : null;

  return (
    <>
      <Backdrop />
      <div
        className={`
                fixed h-full bg-white border-r border-gray-200 transition-all duration-300 shadow-lg flex flex-col
                ${
                  isMobile
                    ? `w-72 z-50 ${isOpen ? "left-0" : "-left-72"}`
                    : `z-30 ${isOpen ? "w-64" : "w-16"}`
                }
            `}
      >
        <div className="flex items-center justify-between p-3 sm:p-4 border-b h-20 sm:h-24 flex-shrink-0">
          <div className="flex items-center min-w-0 ">
            {(isOpen || isMobile) && (
              <>
                
                <img
                  src="/images/headerLogo.png"
                  className="w-20 sm:w-24 lg:w-32 mt-1 min-w-0"
                  alt="DrEasy Logo"
                />
              </>
            )}
          </div>
          {!isMobile && (
            <button
              onClick={onToggle}
              className="text-gray-500 hover:text-gray-700 p-1 rounded-md hover:bg-gray-100 transition-colors flex-shrink-0 flex items-center justify-start gap-1"
            >
              <div
                className={`${isOpen ? "hidden" : "flex"} w-4 h-4 sm:w-6 sm:h-6 rounded-md flex items-center justify-start flex-shrink-0`}
              >
 <img
                  src="/images/logo2.png"
                  className="w-20 sm:w-12 lg:w-20 mt-1 min-w-0"
                  alt="DrEasy Logo"
                />              </div>
              {isOpen ? (
                <FaChevronLeft className="w-4 h-4 text-secondary_hover" />
              ) : (
                <FaChevronRight className="w-4 h-4 text-secondary_hover" />
              )}
            </button>
          )}
        </div>

        <div
          className={`flex-1 overflow-y-auto ${!isMobile && !isOpen ? "hidden" : ""}`}
        >
          <nav className="mt-4 sm:mt-6 pb-4 sm:pb-6">
            <ul className="space-y-1 sm:space-y-2 px-2 sm:px-3">
              {navItems.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    end={item.path === "/"}
                    className={({ isActive }) => `
                                            flex items-center p-2.5 sm:p-3 rounded-md transition-all duration-200 group
                                            ${
                                              isActive
                                                ? "bg-secondary/10 text-secondary_hover font-medium"
                                                : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                            }
                                        `}
                    onClick={isMobile ? onToggle : undefined}
                  >
                    <span className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                      {item.icon}
                    </span>
                    <span className="ml-3 text-sm sm:text-base font-medium truncate">
                      {item.name}
                    </span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Collapsed navigation for desktop only */}
        {!isMobile && !isOpen && (
          <div className="flex-1 overflow-y-auto">
            <nav className="mt-4 pb-4">
              <ul className="space-y-1 px-2">
                {navItems.map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      end={item.path === "/"}
                      className={({ isActive }) => `
                                                flex items-center justify-center p-3 rounded-md transition-all duration-200 group
                                                ${
                                                  isActive
                                                    ? "bg-primary/10 text-primary"
                                                    : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                }
                                            `}
                      title={item.name}
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        {item.icon}
                      </span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}

        {/* User section */}
        <div className="border-t border-gray-200 p-3 sm:p-4 flex-shrink-0">
          <div
            className={`flex items-center ${!isMobile && !isOpen ? "justify-center" : "gap-3"}`}
          >
            {user?.imageId ? (
              <img
                src={getImg(user?.imageId)}
                alt={`dr ${user?.firstName} ${user?.lastName}`}
                className="w-9 h-9 sm:w-11 sm:h-11 rounded-full object-cover bg-gray-200 flex-shrink-0"
              />
            ) : (
              <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-full object-cover bg-gray-200 flex items-center justify-center text-secondary_hover flex-shrink-0">
                <BsHospital size={30} />
              </div>
            )}

            {(isOpen || isMobile) && (
              <div className="min-w-0 flex-1">
                <p className="font-medium text-xs sm:text-sm text-secondary_hover truncate">
                  {user?.firstName} {user?.lastName}
                </p>
                <p className="text-xs text-gray-500 truncate">{user?.email}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
